import { useRef } from 'react'
import { useEffect } from 'react'

import { historyList } from 'assets/data'
import Location from '../assets/icons/location-icon.svg'
import Phone from '../assets/icons/phone-icon.svg'
import Email from '../assets/icons/email-icon.svg'
// import ContactFloatingButton from 'components/ContactFloatingButton'

export function About() {
  return (
    <div className='wrapper '>
      {/* 회사 소개 */}
      <div
        className='flex flex-col items-center justify-center w-full h-[500px] bg-no-repeat bg-cover bg-center'
        style={{ backgroundImage: 'url(' + require('assets/images/about-background.png') + ')' }}
      >
        <div className='flex flex-col items-center justify-center gap-36'>
          <div className='flex flex-col items-center justify-center gap-6'>
            <p className='text-body1-medium sm:text-h2-medium text-sk-assistive'>HISTORY</p>
            <p className='text-title2-bold sm:text-title1-bold text-sk-white'>연혁</p>
          </div>
          <p className='px-10 text-center text-body2-long-medium sm:text-body1-long-medium text-sk-assistive'>
            시그마테크놀로지는 다년간 경험을 바탕으로 고객의 브랜드가치를 극대화시키고
            <br />
            고객사의 발전에 기여할 것을 목표로 하고 있습니다
          </p>
        </div>
      </div>
      {/* 증명서 + 연혁 */}
      <div className='container mx-auto'>
        <div className='flex flex-col items-center justify-center sm:items-start sm:flex-row gap-120 py-120'>
          {/* 증명서 */}
          <div className='flex flex-col items-center gap-24 shrink-0'>
            <img src={require('assets/images/about-certification.png')} alt='' />
            <p className='text-center text-body1-medium text-sk-default'>증명서 이름</p>
          </div>
          {/* 연혁 */}
          <div className='flex flex-col divide-y divide-sk-border px-10 w-full sm:w-[600px]'>
            {historyList.map((history, index) => (
              <div
                key={index}
                className='flex flex-col items-center gap-24 py-40 sm:items-start sm:gap-40 sm:py-60 md:py-80 first:pt-0 last:pb-0'
              >
                <p className='items-start text-title1-bold md:text-display2-bold text-sk-default'>
                  {history.year}
                </p>
                {Array.from(new Set(history.content.map((content) => content.month))).map(
                  (month, monthIndex) => (
                    <div key={monthIndex} className='flex gap-16'>
                      <p className='text-body1-medium md:text-h2-medium text-sk-info shrink-0'>
                        {month}
                      </p>
                      <div className='flex flex-col gap-10 sm:gap-[19px]'>
                        {history.content
                          .filter((item) => item.month === month)
                          .map((content, index) => (
                            <p
                              key={index}
                              className='text-h2-semibold md:text-h1-semibold text-sk-default'
                            >
                              {content.text}
                            </p>
                          ))}
                      </div>
                    </div>
                  )
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <ContactFloatingButton /> */}
    </div>
  )
}

export function AboutLocation() {
  const mapRef = useRef(null)
  const lat = 37.480033 // 위도
  const lng = 126.878112 // 경도

  useEffect(() => {
    const { naver } = window
    if (mapRef.current && naver) {
      const location = new naver.maps.LatLng(lat, lng)
      const map = new naver.maps.Map(mapRef.current, {
        center: location,
        zoom: 17, // 지도 확대 정도
      })
      new naver.maps.Marker({
        position: location,
        map,
      })
    }
  }, [])

  return (
    <div className='wrapper '>
      <div
        className='flex flex-col items-center justify-center w-full h-[500px] bg-no-repeat bg-cover bg-center'
        style={{ backgroundImage: 'url(' + require('assets/images/about-background.png') + ')' }}
      >
        <div className='flex flex-col items-center justify-center gap-36'>
          <div className='flex flex-col items-center justify-center gap-6'>
            <p className='text-body1-medium sm:text-h2-medium text-sk-assistive'>Location</p>
            <p className='text-title2-bold sm:text-title1-bold text-sk-white'>오시는 길</p>
          </div>
          <p className='text-center text-body2-long-medium sm:text-body1-long-medium text-sk-assistive'>
            시그마테크놀로지 사무실로 오시는 길을
            <br />
            안내드립니다
          </p>
        </div>
      </div>
      <div className='flex flex-col items-center justify-center gap-48 sm:gap-64 py-80 bg-sk-white'>
        {/* <img src={require('assets/images/about-location.png')} alt='' /> */}
        <div
          ref={mapRef}
          className='h-[400px] sm:h-[600px] w-[300px] 2xs:w-[400px] sm:w-[600px] md:w-[700px] lg:w-[1000px] xl:w-[1280px]'
        ></div>

        <div className='items-center justify-center w-full flex-col md:flex md:flex-row divide-y-[1px] md:divide-y-0 md:divide-x-[1px] divide-solid divide-neutral-90 px-20 sm:px-0'>
          <div className='flex flex-col gap-20 sm:px-[92px] py-20 items-center '>
            <img src={Location} className='w-48 h-48' alt='' />
            <div className='flex flex-col gap-12'>
              <p className='text-center text-h2-semibold sm:text-h1-semibold text-sk-black'>
                LOCATION
              </p>
              <p className='text-center text-body2-long-medium sm:text-body1-long-medium text-sk-sub shrink-0'>
                서울특별시 금천구 가산디지털2로 135, <br />
                1215~1216호
              </p>
            </div>
          </div>
          <div className='flex flex-col gap-20 sm:px-[92px] py-20 items-center'>
            <img src={Phone} className='w-48 h-48' alt='' />
            <div className='flex flex-col gap-12'>
              <p className='text-center text-h2-semibold sm:text-h1-semibold text-sk-black'>TEL</p>
              <p className='flex text-center text-body2-long-medium sm:text-body1-long-medium text-sk-sub shrink-0'>
                +82 010-9162-3187
              </p>
            </div>
          </div>
          <div className='flex flex-col gap-20 sm:px-[92px] py-20 items-center'>
            <img src={Email} className='w-48 h-48' alt='' />
            <div className='flex flex-col gap-12'>
              <p className='text-center text-h2-semibold sm:text-h1-semibold text-sk-black'>MAIL</p>
              <p className='text-center text-body2-long-medium sm:text-body1-long-medium text-sk-sub shrink-0'>
                jeong@sigmatechnology.io
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* <ContactFloatingButton /> */}
    </div>
  )
}
